import { render, staticRenderFns } from "./AppTabSubscriptionUserPlan.vue?vue&type=template&id=1a87ca7c&scoped=true"
import script from "./AppTabSubscriptionUserPlan.vue?vue&type=script&lang=js"
export * from "./AppTabSubscriptionUserPlan.vue?vue&type=script&lang=js"
import style0 from "./AppTabSubscriptionUserPlan.vue?vue&type=style&index=0&id=1a87ca7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87ca7c",
  null
  
)

export default component.exports